import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SelectItem} from 'primeng/api';
import {TerceroUpPasarelaProductoService} from '../../../../../_services/tercero-up-pasarela-producto.service';
import {TerceroUPPasarelaProducto} from '../../../../../_models/tercero-up-pasarela-producto';
import {ListaService} from '../../../../../_services/lista.service';
import {ListaItem} from '../../../../../_models/lista-item';
import {NavService} from '../../../../../_services/_nav.service';
import {AdmsbTarifaMetodo} from '../../../../../_models/admsb-titular';
import {claseEstado, filtrarPorTexto} from '../../admsb-titular.helpers';

const TITULO_EDITAR_TARIFA = 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_EDITARTARIFA';

@Component({
  selector: 'app-admsb-tarifas-tabla',
  templateUrl: './admsb-tarifas-tabla.component.html',
  styleUrls: ['./admsb-tarifas-tabla.component.scss'],
})
export class AdmsbTarifasTablaComponent implements OnInit {

  /** Identificador de la pasarela del titular (idTerceroUPPasarela) */
  @Input() idTitular: string;

  tarifas: AdmsbTarifaMetodo[] = [];
  cargandoTarifas = true;

  /** Texto del buscador de la tabla de tarifas*/
  filtroTarifas = '';

  /** Registros crudos del servicio */
  private tarifasCrudo: TerceroUPPasarelaProducto[] = [];

  /** Registro crudo correspondiente a la tarifa que está siendo editada en el sidebar */
  private tarifaSeleccionada: TerceroUPPasarelaProducto | null = null;

  /** Controla la visibilidad del sidebar de edición */
  sidebarVisible = false;

  /** título mostrado en el sidebar */
  readonly tituloSidebar = TITULO_EDITAR_TARIFA;

  /** Opciones de los dropdowns del panel "Editar tarifa" */
  metodosPasarela: SelectItem[] = [];
  estadosPasarela: SelectItem[] = [];

  /** Controla la visualización de los mensajes de validación del panel "Editar tarifa" */
  submittedTarifa = false;

  /** Registro editado en el panel "Editar tarifa" */
  tarifaEditando: { idMetodo: string | null; idEstado: string | null; habilitado: boolean } =
    {idMetodo: null, idEstado: null, habilitado: true};

  /** Modificador de color del chip de estado */
  claseEstado = claseEstado;

  constructor(
    private router: Router,
    private listaServicio: ListaService,
    private terceroUpPasarelaProductoServicio: TerceroUpPasarelaProductoService,
    private navService: NavService,
  ) {
  }

  ngOnInit(): void {
    this.listaServicio.getMasterDetails('ListasTiposMetodosPasarela').subscribe(res =>
      this.metodosPasarela = res.map((s: ListaItem) => ({label: s.nombre, value: s.idLista})));
    this.listaServicio.getMasterDetails('ListasEstadosPasarela').subscribe(res =>
      this.estadosPasarela = res.map((s: ListaItem) => ({label: s.nombre, value: s.idLista})));

    if (this.idTitular) {
      this.cargarTarifas(this.idTitular);
    } else {
      this.cargandoTarifas = false;
    }
  }

  private cargarTarifas(idTerceroUPPasarela: string): void {
    this.terceroUpPasarelaProductoServicio.listMetodosPasarela(idTerceroUPPasarela).subscribe({
      next: res => {
        this.tarifasCrudo = res;
        this.tarifas = res.map((p: TerceroUPPasarelaProducto) => ({
          id: p.idTerceroUPPasarelaProducto || p.codigoMetodoLista,
          metodo: p.nombreMetodoLista || p.codigoMetodoLista,
          estado: p.nombreEstadoPasarela || p.codigoEstadoPasarela,
          habilitado: !!p.indicadorHabilitado,
        }));
        this.cargandoTarifas = false;
      },
      error: () => this.cargandoTarifas = false,
    });
  }

  /**
   * Tarifas filtradas localmente por según el texto del buscador
   */
  get tarifasFiltradas(): AdmsbTarifaMetodo[] {
    return filtrarPorTexto(this.tarifas, this.filtroTarifas, [t => t.metodo, t => t.estado]);
  }

  irATarifas(tarifa: AdmsbTarifaMetodo): void {
    this.router.navigate(['apl/administrador-servicios-bancarios/titular/' + this.idTitular + '/tarifas/' + tarifa.id]);
  }

  /**
   * Abre el sidebar de edición de tarifa
   */
  abrirSidebarEdicionTarifa(tarifa: AdmsbTarifaMetodo): void {
    this.submittedTarifa = false;
    this.tarifaSeleccionada = this.tarifasCrudo.find(p =>
      (p.idTerceroUPPasarelaProducto || p.codigoMetodoLista) === tarifa.id) ?? null;
    this.tarifaEditando = {
      idMetodo: this.buscarValorPorEtiqueta(this.metodosPasarela, tarifa.metodo),
      idEstado: this.buscarValorPorEtiqueta(this.estadosPasarela, tarifa.estado),
      habilitado: tarifa.habilitado,
    };
    this.sidebarVisible = true;
  }

  cerrarSidebarEdicion(): void {
    this.sidebarVisible = false;
  }

  private buscarValorPorEtiqueta(opciones: SelectItem[], etiqueta: string): string | null {
    const opcion = opciones.find(o => (o.label ?? '').toLowerCase() === (etiqueta ?? '').toLowerCase());
    return opcion ? opcion.value : null;
  }

  /**
   * Valida los campos obligatorios del panel "Editar tarifa" y guarda la nueva versión del registro
   */
  guardarTarifa(): void {
    this.submittedTarifa = true;
    if (!this.tarifaEditando.idMetodo || !this.tarifaEditando.idEstado || !this.tarifaSeleccionada) {
      return;
    }

    const registro: TerceroUPPasarelaProducto = {
      ...this.tarifaSeleccionada,
      idEstadoPasarela: this.tarifaEditando.idEstado,
      indicadorHabilitado: this.tarifaEditando.habilitado,
    };

    this.terceroUpPasarelaProductoServicio.crearPasarelaVersion(registro).subscribe({
      next: () => {
        this.navService.setMesage(2);
        this.cargarTarifas(this.idTitular);
        this.cerrarSidebarEdicion();
      },
      error: () => this.navService.setMesage(3),
    });
  }

}
